import { Decimal } from 'decimal.js-light';
import { DECIMAL_DIGITS } from 'src/modules/common/constants.ts';

export const calcPressureFromHeight = (
    heightMeter: string,
    density: string,
) => {
    try {
        return new Decimal(heightMeter)
            .mul(new Decimal(density))
            .mul(9.81)
            .toFixed(DECIMAL_DIGITS);
    } catch {
        return '';
    }
};
